<template>
  <v-container>
    <calendar @dateChanged="dateChanged" />
    <diary-list :userType="userType" :selectedDate="selectedDate" @checked="checked" />
    <v-btn
      v-if="userType == 'challenger' && writeValid === true"
      @click="diaryDateValid()"
      class="diaryButton"
      color="primary"
    >
      <v-icon>mdi-lead-pencil</v-icon>
    </v-btn>
    <Admob :ad="ad" @closed="ad = false" @succeed="writeDiary" />
    <!-- <overlay-loader :overlay="ad" /> -->
  </v-container>
</template>
<script>
import calendar from "@/components/calendar/Calendar";
import DiaryList from "../../components/calendar/DiaryList.vue";
import Admob from "../../components/Admob.vue";
// import OverlayLoader from '../../components/OverlayLoader.vue';
export default {
  name: "Home",
  components: {
    calendar,
    Admob,
    DiaryList,
    // OverlayLoader,
  },

  data() {
    return {
      selectedDate: undefined,
      selectedMonth: undefined,
      writeValid: true,
      ad: false,
      userType: undefined,
    };
  },
  computed: {
    // userType() {
    //   return this.$store.getters.userType;
    // },
    challengeId() {
      return this.$store.getters.challengeId;
    },
    today() {
      var today = new Date();
      var dd = String(today.getDate());
      var mm = String(today.getMonth() + 1);
      mm = mm >= 10 ? mm : "0" + mm;
      dd = dd >= 10 ? dd : "0" + dd;
      var yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd + "";

      return today;
    },
  },
  methods: {
    checked(v){
      this.writeValid = v;
    },
    dateChanged(date) {
      this.selectedDate = date;
      this.writeValid = false;
      if (this.selectedDate == this.today) {
        this.writeValid = true;
      }
    },
    chekcNotification() {
      // this.$store.dispatch("checkNotification", {
      //   body: { challengeId: this.challengeId },
      // });
      const localStorageUser = window.localStorage.getItem("pushToken");
      if(localStorageUser == "challengertoken"){
        this.userType = "challenger";
      }else{
        this.userType = "helper";
      }
    },
    diaryDateValid() {
      if (this.selectedDate < this.today) {
        this.ad = true;
      } else {
        this.writeDiary();
      }
    },
    writeDiary() {
      // this.$router.push("/diary/write?date=" + this.selectedDate);
      this.$router.push("/diary/write");
    },
  },
  async mounted() {
    this.chekcNotification();
  },
};
</script>
<style lang="scss" scoped>
.diaryButton {
  min-width: auto !important;
  width: 64px;
  height: 64px !important;
  border-radius: 100% !important;
  position: fixed;
  bottom: 74px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  background-color: #002481;
  box-sizing: border-box;

  i {
    color: inherit;
    font-size: 32px;
  }
}
</style>